import { useState } from 'react'
import { MapContainer } from '../Dashboard/components/MapContainer'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { SidebarProvider } from '@/components/ui/sidebar'
import { FleetOverview } from '../Dashboard/components/FleetOverview'
import { RealTimeAlerts } from '../Dashboard/components/RealTimeAlerts'
import { VehicleDetailsSheet } from '../Dashboard/components/VehicleDetailsSheet'
import { MapControls } from '../Dashboard/components/MapControls'

export function LiveFleet() {
  const [selectedVehicleId, setSelectedVehicleId] = useState<string | null>(null)
  const [isVehicleSheetOpen, setIsVehicleSheetOpen] = useState(false)

  const handleVehicleClick = (vehicleId: string) => {
    setSelectedVehicleId(vehicleId)
    setIsVehicleSheetOpen(true)
  }

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full">
        <AppSidebar />

        <main className="flex-1 relative overflow-hidden">
          {/* Map Container */}
          <MapContainer onVehicleClick={handleVehicleClick} />

          {/* Map Controls (Layers & Filters) */}
          <MapControls />

          {/* Fleet Overview Card - Top Right */}
          <div className="absolute top-4 right-4 z-10">
            <FleetOverview />
          </div>

          {/* Real-Time Alerts Card - Bottom Right */}
          <div className="absolute bottom-4 right-4 z-10">
            <RealTimeAlerts />
          </div>

          {/* Vehicle Details Sheet */}
          <VehicleDetailsSheet
            vehicleId={selectedVehicleId}
            open={isVehicleSheetOpen}
            onOpenChange={setIsVehicleSheetOpen}
          />
        </main>
      </div>
    </SidebarProvider>
  )
}
